import React, { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import partnerService from "../../../services/partners";
import imageUpload from "../../../services/upload";
import {
  Card,
  CardContent,
  CardActions,
  Box,
  InputLabel,
  Select,
  MenuItem,
  Breadcrumbs,
  FormControl,
  TextField,
  FormHelperText,
  Button,
  Typography,
  CardMedia,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import { IMAGE_PATH, instanceToken } from "../../../utils/constant";
import partners from "../../../services/partners";
import { CreateNewPrivilegeSchema } from "../../../schema/CreateNewPrivilegeSchema";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";

const imgFileTypes = ["image/gif", "image/jpeg", "image/png", "image/svg+xml"];

export default function CreatePrivilege({ homeAlert }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState("");
  const [imageFile, setImageFile] = useState("");
  const [imageFileUrl, setImageFileUrl] = useState("");
  const [values, setValues] = useState({ image_url: "" });

  const [nameEng, setNameEng] = useState("");
  const [nameMM, setNameMM] = useState("");
  const [addressEng, setAddressEng] = useState("");
  const [addressMM, setAddressMM] = useState("");
  const [phone, setPhone] = useState("");
  const [phoneNote, setPhoneNote] = useState("");
  const [link, setLink] = useState("");
  const [category, setCategory] = useState("");
  const [errorMessage, setErrorMessage] = useState({});

  const [, setPartner] = useState(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(CreateNewPrivilegeSchema),
    initialValues: {
      name_en: "",
      name_mm: "",
      address_en: "",
      address_mm: "",
      phone: "",
      phone_note: "",
      category: "",
      promotion: "",
      link: "",
    },
  });

  async function getImageUrl(imgData) {
    const response = await imageUpload.getImageUrl(
      instanceToken.token,
      imgData
    );
    const result = response.data;
    const path = IMAGE_PATH + result?.imageName;
    setImageFileUrl(result?.imageUploadUrl);
    setValues({
      ...values,
      image_url: path,
    });
  }
  const changeFile = async (e) => {
    if (e.target.files && e.target.files[0]) {
      if (e.target.files && e.target.files[0]) {
        const img = e.target.files[0];
        if (!imgFileTypes.includes(img.type)) {
          setErrorMessage({
            ...errorMessage,
            image_url: "Please select image. (PNG, JPG, JPEG, GIF, ...)",
          });
          return;
        }
        if (img.size > 204800) {
          setErrorMessage({
            ...errorMessage,
            image_url: "Image file size must be smaller than 200KB.",
          });
          return;
        }
        setImageFile(img);
        setImagePreview(URL.createObjectURL(img));
        getImageUrl(img);
      }
    }
  };

  const formData = new FormData();

  const handleCreate = async (data) => {
    console.log("===========", data);
    formData.append("name_en", data?.name_en);
    formData.append("name_mm", data?.name_mm);
    formData.append("address_en", data?.address_en);
    formData.append("address_mm", data?.address_mm);
    formData.append("phone", data?.phone);
    formData.append("phone_note", data?.phone_note);
    formData.append("link", data?.link);
    formData.append("category", data?.category);
    formData.append("image_data", "");
    formData.append("image_url", values?.image_url);
    formData.append("promotion", data?.promotion);

    try {
      setLoading(true);
      console.log(formData.category);
      await imageUpload.uploadImage(imageFileUrl, imageFile);
      const response = await partners.postPartner(
        instanceToken.token,
        formData
      );
      setPartner(response.data);
      navigate("/privileges");
      homeAlert("New Privilege have been created.", false);
    } catch (error) {
      console.log(error);
      homeAlert("Error on server.", true);
    } finally {
      setLoading(false);
      setErrorMessage({});
    }
  };
  return (
    <form onSubmit={handleSubmit(handleCreate)}>
      <div role="presentation" style={{ marginBlockEnd: "10px" }}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link to="/privileges">Privilege</Link>
          <span>Create Privilege</span>
        </Breadcrumbs>
      </div>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Card sx={{ minWidth: "80vw" }}>
          <CardContent sx={{ display: "flex", pb: 0, flexDirection: "column" }}>
            <Box
              sx={{
                maxWidth: "40vw",
                display: "grid",
                justifyContent: "center",
                // bgcolor: "red",
                ml: 31,
                borderRadius: 2,
                boxShadow: 2,
              }}
            >
              <CardMedia
                component="img"
                height="320"
                image={imagePreview}
                sx={{ my: 2 }}
              />
            </Box>

            <Box sx={{ display: "flex", justifyContent: "center" }}>
              {/* image */}
              <FormControl sx={{ my: 2, maxWidth: 400 }}>
                <Typography
                  sx={{
                    mb: 1,
                    fontSize: "12px",
                    display: "flex",
                    textAlign: "center",
                  }}
                >
                  Rendered size must be 340 * 180 px , Aspect ratio must be
                  1.8:1 and resolution must be 72ppi
                </Typography>
                <Button
                  variant="contained"
                  component="label"
                  size="large"
                  sx={{ p: 2 }}
                >
                  <PhotoCamera />
                  <Typography sx={{ ml: 1 }}>Upload Image</Typography>
                  <input
                    hidden
                    onChange={changeFile}
                    accept="image/png, image/jpeg, image/jpg, image/gif, image/svg+xml"
                    type="file"
                    error={errorMessage["image_url"]}
                    helperText={errorMessage["image_url"]}
                  />
                </Button>
                {errorMessage.category && (
                  <FormHelperText error>{errorMessage.category}</FormHelperText>
                )}
                <FormHelperText error>
                  {errorMessage["image_url"]}
                </FormHelperText>
              </FormControl>
            </Box>
            {/* name */}
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                px: 3,
                columnGap: 5,
              }}
            >
              {/* name Eng */}
              <FormControl sx={{ my: 2, maxWidth: 800 }} variant="outlined">
                <TextField
                  id="name_en"
                  label="Name Eng"
                  {...register("name_en")}
                  error={!!errors.name_en}
                  helperText={errors.name_en?.message}
                />
              </FormControl>
              {/* Nmae MM */}
              <FormControl sx={{ my: 2 }} variant="outlined">
                <TextField
                  id="name_mm"
                  label="Name MM"
                  {...register("name_mm")}
                  error={!!errors.name_en}
                  helperText={errors.name_en?.message}
                />
              </FormControl>
            </Box>
            {/* address */}
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                px: 3,
                columnGap: 5,
              }}
            >
              {/* address Eng */}
              <FormControl sx={{ my: 2, maxWidth: 800 }} variant="outlined">
                <TextField
                  id="address_en"
                  label="Address Eng"
                  {...register("address_en")}
                  error={!!errors.address_en}
                  helperText={errors.address_en?.message}
                />
              </FormControl>
              {/* Address MM */}
              <FormControl sx={{ my: 2 }} variant="outlined">
                <TextField
                  id="address_mm"
                  label="Address MM"
                  {...register("address_mm")}
                  error={!!errors.address_mm}
                  helperText={errors.address_mm?.message}
                />
              </FormControl>
            </Box>
            {/* description */}

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                px: 3,
                columnGap: 5,
              }}
            >
              {/* phone*/}
              <FormControl sx={{ my: 2, maxWidth: 800 }}>
                <TextField
                  id="phone"
                  label="Phone"
                  {...register("phone")}
                  error={!!errors.phone}
                  helperText={errors.phone?.message}
                />
              </FormControl>

              <FormControl sx={{ my: 2 }}>
                <TextField
                  id="phone_note"
                  label="Phone Note (Optional)"
                  {...register("phone_note")}
                  error={!!errors.phone_note}
                  helperText={errors.phone_note?.message}
                />
              </FormControl>

              {/* link */}
              <FormControl sx={{ my: 2 }}>
                <TextField
                  id="link"
                  label="Link"
                  {...register("link")}
                  error={!!errors.link}
                  helperText={errors.link?.message}
                />
              </FormControl>
              {/* Category */}
              <FormControl sx={{ my: 2 }}>
                <InputLabel id="category">Category</InputLabel>
                <Select
                  labelId="category"
                  label="category"
                  defaultValue=""
                  {...register("category")}
                  error={!!errors.category}
                  helperText={errors.category?.message}
                >
                  <MenuItem value="" disabled>
                    Value
                  </MenuItem>
                  <MenuItem value="Hospital">Hospital</MenuItem>
                  <MenuItem value="Private-Hospital">Private-Hospital</MenuItem>
                  <MenuItem value="Education">Education</MenuItem>
                  <MenuItem value="Fitness">Fitness</MenuItem>
                  <MenuItem value="Hotel">Hotel</MenuItem>
                </Select>
                {errorMessage.category && (
                  <FormHelperText error>{errorMessage.category}</FormHelperText>
                )}
                <FormHelperText error>
                  {errorMessage["category"]}
                </FormHelperText>
              </FormControl>
              {/* Email*/}
            </Box>

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                px: 3,
                columnGap: 5,
              }}
            >
              {/* name Eng */}
              <FormControl sx={{ my: 2, maxWidth: 800 }} variant="outlined">
                <TextField
                  id="promotion"
                  label="Promotion"
                  {...register("promotion")}
                  error={!!errors.promotion}
                  helperText={errors.promotion?.message}
                />
              </FormControl>
            </Box>
          </CardContent>

          <CardActions sx={{ justifyContent: "end" }}>
            <LoadingButton
              type="submit"
              variant="contained"
              loading={loading}
              // onClick={handleCreate}
              sx={{ backgroundColor: "#4b26d1", alignSelf: "end" }}
            >
              Create
            </LoadingButton>
          </CardActions>
        </Card>
      </Box>
    </form>
  );
}
